import { CSSProperties } from "react";
import { IconType } from "react-icons/lib";

import { cn } from "@bentolabs/kit/utils";
type Props = {
  style?: CSSProperties;
  className?: string;
  message: string;
  icon: IconType;
};

export const Toast = (props: Props) => {
  const { style, className, message, icon: Icon } = props;
  return (
    <div
      style={{
        backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), radial-gradient(76.6% 100% at 50% 100%, rgba(34, 237, 78, 0.4) 0%, rgba(34, 237, 78, 0.2) 100%)`,
        boxShadow: "0px 1px 1px 0px #22ED4E40 inset",
        ...style,
      }}
      className={cn(
        "flex w-full items-center gap-x-4 rounded-tl-2xl rounded-tr-2xl px-2 pt-2 pb-2 leading-[105%] text-current backdrop-blur-3xl",
        className
      )}
    >
      <div className="flex size-8.5 shrink-0 items-center justify-center rounded-[10px] bg-current/20">
        <Icon className="size-6 text-current" />
      </div>
      <div className="line-clamp-2 overflow-hidden text-ellipsis">
        {message}
      </div>
    </div>
  );
};
